import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PageHeader from '../../components/PageHeader.jsx';
import { ErrorBox } from '../../components/Loader.jsx';
import TaskForm from './TaskForm.jsx';
import { TasksAPI } from '../../lib/api';
import { buildPath, isIndividualUser } from '../../config';
import { useAuth } from '../../lib/auth.jsx';

export default function TaskCreate() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const solo = isIndividualUser(user);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (payload) => {
    setSubmitting(true);
    setError(null);
    try {
      const created = await TasksAPI.create(payload);
      navigate(buildPath.taskDetails(created.id));
    } catch (e) {
      setError(e);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <PageHeader
        title="Create Task"
        subtitle={
          solo
            ? 'Create a task for yourself.'
            : 'Assign a new task to yourself or your team.'
        }
      />
      <ErrorBox error={error} />
      <TaskForm onSubmit={onSubmit} submitting={submitting} />
    </>
  );
}
